import { Link } from 'react-router-dom';
import { resources } from '@/mocks/resources';

export default function FeaturedDownloads() {
  const featured = resources.slice(0, 8);

  const formatDownloads = (num: number) => {
    if (num >= 10000) {
      return `${(num / 10000).toFixed(1)}万`;
    }
    return num.toString();
  };

  return (
    <section className="w-full py-14 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">
              最受用户欢迎的精选资源，高评分高下载量
            </p>
          </div>
          <Link
            to="/category"
            className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-product-shop>
          {featured.map((res) => (
            <div
              key={res.id}
              className="group p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 transition-all"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className={`${res.icon} text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">
                    {res.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    {res.version} · {res.size}
                  </p>
                </div>
              </div>

              <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                {res.description}
              </p>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-xs font-medium text-foreground-700">{res.rating}</span>
                  <span className="text-xs text-foreground-400 ml-1">
                    {formatDownloads(res.downloads)}次下载
                  </span>
                </div>
                <div className="flex items-center gap-1.5">
                  {res.platform.slice(0, 3).map((p) => (
                    <span key={p} className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {p}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}